(function () {
  'use strict';

  function configuration(
    hqTLightingLanguageProvider,
    hqTLightingRouterProvider
  ) {
    'ngInject';

    /* Set-up languages */
    hqTLightingLanguageProvider
      .registerAvailableLanguages()
      .setSanitizeStrategy()
      .updateLanguageFromHtml()
      .setPreferedLanguage()
      .loadJson();

    /* Set-up routing */
    hqTLightingRouterProvider
      .setState();
  }

  function run($transitions, $state, hqTLightingOptions) {
    // TODO This will check for exterior/interior in the future
    if (hqTLightingOptions.roomSelection === null) {
      $state.go('start');
    }

    $transitions.onSuccess({}, function (trans) {
      var hqTLightingHeaderToggle = trans.injector().get('hqTLightingHeaderToggle');
      var hqTLightingScrollTo = trans.injector().get('hqTLightingScrollTo');
      var $timeout = trans.injector().get('$timeout');

      $timeout(function () {
        hqTLightingHeaderToggle(trans.router.stateService.current.name === 'start');
        hqTLightingScrollTo();
      });
    });
  }

  angular
    .module('hq.tools.lighting', [
      'pascalprecht.translate',
      'ngA11y',
      'ui.router',
      'ngSanitize',
      'slickCarousel',
      'hl.sticky',
    ])
    .config(configuration)
    .constant('THEME_BASE_PATH', '/themes/')
    .constant('THEME_TITLE', 'mieux-consommer/')
    .constant('OPTIONS_PATH', 'donnees/options.json')
    .constant('TRANSLATIONS_PREFIX', 'donnees/content_')
    .run(run);
}());
